var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50065 15.1668C4.54732 15.1668 1.33398 11.9535 1.33398 8.00016C1.33398 4.04683 4.54732 0.833496 8.50065 0.833496C12.454 0.833496 15.6673 4.04683 15.6673 8.00016C15.6673 11.9535 12.454 15.1668 8.50065 15.1668ZM8.50065 1.8335C5.10065 1.8335 2.33398 4.60016 2.33398 8.00016C2.33398 11.4002 5.10065 14.1668 8.50065 14.1668C11.9007 14.1668 14.6673 11.4002 14.6673 8.00016C14.6673 4.60016 11.9007 1.8335 8.50065 1.8335Z",
    fill: "#6B788F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50053 9.17017C8.2272 9.17017 8.00053 8.9435 8.00053 8.67017V8.53019C8.00053 7.75686 8.56718 7.37685 8.78052 7.23018C9.02718 7.06352 9.10718 6.95019 9.10718 6.77686C9.10718 6.44352 8.83386 6.17017 8.50053 6.17017C8.1672 6.17017 7.89388 6.44352 7.89388 6.77686C7.89388 7.05019 7.66721 7.27686 7.39388 7.27686C7.12055 7.27686 6.89388 7.05019 6.89388 6.77686C6.89388 5.89019 7.61386 5.17017 8.50053 5.17017C9.3872 5.17017 10.1072 5.89019 10.1072 6.77686C10.1072 7.53686 9.5472 7.91684 9.34054 8.05684C9.08054 8.23018 9.00053 8.34353 9.00053 8.53019V8.67017C9.00053 8.95017 8.77386 9.17017 8.50053 9.17017Z",
    fill: "#6B788F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50065 10.8302C8.22065 10.8302 8.00065 10.6035 8.00065 10.3302C8.00065 10.0568 8.22732 9.83016 8.50065 9.83016C8.77398 9.83016 9.00065 10.0568 9.00065 10.3302C9.00065 10.6035 8.78065 10.8302 8.50065 10.8302Z",
    fill: "#6B788F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.2daa0df4a99866bc3da13be01accd7b3.svg";
export { ForwardRef as ReactComponent };